import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { officeAplicacionListComponent } from '../../security/officeAplicacion/officeAplicacionList/officeAplicacion.component';
import { NgModule } from '@angular/core';
import { AplicacionService } from '../../security/Aplicaciones/shared/aplicacion.service';
import { officeAplicacionService} from '../officeAplicacion/shared/officeAplicacion.service'
import { OfficeAplicacionRoutingModule,ROUTABLE_COMPONENTS} from '../officeAplicacion/officeAplicacion.routing';
import { MatButtonModule, MatInputModule,MatSelectModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule,MatFormFieldModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { officeaAplicacionComponent } from '../officeAplicacion/officeApp.component'


//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';


@NgModule({
    imports: [
      BrowserModule,
      FormsModule, ReactiveFormsModule,
      OfficeAplicacionRoutingModule,
      MatTableModule, MatCheckboxModule, MatButtonModule, MatInputModule, MatSlideToggleModule,
      MatFormFieldModule,MatPaginatorModule,
      FabButtonGroupModule, SectionBarModule,MatSelectModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [

      officeAplicacionListComponent,
      officeaAplicacionComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [AplicacionService,officeAplicacionService],
    bootstrap: []
})
export class OfficeAplicacionModule {
}
